
import { MouseEvent } from "react";
import { useContentSelection } from "@/contexts/selection/SelectionContext";

interface SelectionHandlerOptions {
  contentId: string;
  allContentIds: string[];
  onClick?: () => void;
}

export const useSelectionHandlers = ({ contentId, allContentIds, onClick }: SelectionHandlerOptions) => {
  const { 
    isSelected, 
    toggleSelection, 
    selectRange, 
    lastSelectedId, 
    clearSelection 
  } = useContentSelection();
  
  const selected = isSelected(contentId);

  const handleSelectionClick = (e: MouseEvent) => {
    e.stopPropagation();
    
    // Shift+click for range selection
    if (e.shiftKey && lastSelectedId) {
      selectRange(lastSelectedId, contentId, allContentIds);
    }
    // Ctrl/Cmd+click for toggle individual selection
    else if (e.ctrlKey || e.metaKey) {
      toggleSelection(contentId, true);
    }
    // Regular click
    else {
      // If not already selected, select just this item
      if (!selected) {
        toggleSelection(contentId);
      }
      
      // Call the original onClick handler if provided
      // Only when not doing multi-selection operations
      if (onClick) {
        onClick();
      }
    }
  };
  
  return {
    selected,
    handleSelectionClick,
    // Export other selection actions for convenience
    clearSelection
  };
};
